import type { MechKey } from './keys';

export const ko: Partial<Record<MechKey, string>> = {
  'app.eyebrow': '역학 · 2D',
  'panel.scene': '장면',
  'panel.dims': '매개변수',
  'panel.style': '외관',
  'panel.action': '제어',
  'style.body': '물체',
  'style.vector': '벡터',
  'style.ground': '지면',
  'style.forces': '힘 표시',
  'style.trace': '궤적 표시',
  'style.labels': '벡터 레이블',
  'hint.line1': '재생을 클릭하여 시작 · 물체를 드래그하여 이동',
  'hint.line2': '샌드박스: 모양을 선택한 후 클릭하여 배치',
  'scene.incline': '경사면',
  'scene.projectile': '포물선 운동',
  'scene.pendulum': '진자',
  'scene.springMass': '용수철-질량 시스템',
  'scene.collisions': '충돌',
  'scene.atwood': '애트우드 기계',
  'scene.circular': '원운동',
  'scene.sandbox': '샌드박스',
  'dim.angle': '각도 (°)',
  'dim.friction': '마찰',
  'dim.mass': '질량',
  'dim.massA': '질량 A',
  'dim.massB': '질량 B',
  'dim.velocity': '속도',
  'dim.angleLaunch': '발사 각도 (°)',
  'dim.gravity': '중력',
  'dim.gravityX': '중력 x',
  'dim.gravityY': '중력 y',
  'dim.length': '길이',
  'dim.damping': '감쇠',
  'dim.spring': '강성',
  'dim.restitution': '반발 계수',
  'dim.radius': '반지름',
  'dim.speed': '속력',
  'action.play': '재생',
  'action.pause': '일시 정지',
  'action.step': '단계',
  'action.reset': '초기화',
  'action.speed': '속도',
  'action.clear': '지우기',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': '중력',
  'forceName.normal': '수직 항력',
  'forceName.friction': '마찰력',
  'forceName.tension': '장력',
  'forceName.spring': '탄성력',
  'forceName.applied': '적용된 힘',
  'forceName.air': '공기 저항',
  'palette.box': '상자',
  'palette.circle': '공',
  'palette.ramp': '경사로',
  'palette.ground': '지면',
  'palette.hint': '모양을 선택한 후 캔버스를 클릭하여 배치하세요.',
  'panel.forces': '관찰된 힘',
  'forces.empty': '아직 없음 — 장면을 재생하세요',
};
